///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportTax = Meevo.Plugins.Reports.IReportTax;

    export class ReportTaxesCollection extends SmartMoverApiCollection<IReportTax> implements IApiCollection<IReportTax> {

        protected get CollectionModel() {
            return ReportTaxesModel;
        }

        protected get url() {
            return 'Report/TaxType';
        }

        public setSelectedValue(selected: boolean): void {
            this.models.forEach((model) => {
                if (model.isActive) model.selected = selected;
            });
        }
    }
}
